<div class="loading-overlay" *ngIf="isLoading">
  <mat-progress-spinner
    mode="indeterminate"
    color="primary"
  ></mat-progress-spinner>
</div>

<div class="title">
  <h1>Visualizar aviso</h1>
</div>

<hr class="divider" />

<div class="aviso">
  <span class="status" [ngClass]="getStatusClass()"> {{ aviso.status }} </span>

  <h3>{{ aviso.titulo }}</h3>

  <div class="datetime">
    <span>Data e hora do disparo:</span>
    <p>{{ aviso.dataAgendamento }}</p>
  </div>

  <div class="message">
    <p>{{ aviso.mensagem }}</p>
  </div>
  <div class="recipients">
    <h3>Destinatários:</h3>

    <div class="groups" *ngIf="gruposSelecionados.length > 0">
      <h4>Grupo de empresa:</h4>
      <div class="items" *ngFor="let grupo of gruposSelecionados">
        <span>{{ grupo.nome }}</span>
      </div>
    </div>

    <div class="companies" *ngIf="empresasSelecionadas.length > 0">
      <h4>Empresa:</h4>
      <div class="items" *ngFor="let empresa of empresasSelecionadas">
        <span>{{ empresa.nome }}</span>
      </div>
    </div>

    <div class="companies" *ngIf="usuariosSelecionados.length > 0">
      <h4>Usuários:</h4>
      <div class="items" *ngFor="let usuario of usuariosSelecionados">
        <span>{{ usuario.nome }}</span>
      </div>
    </div>

    <div class="companies" *ngIf="pessoasSelecionadas.length > 0">
      <h4>Pessoas:</h4>
      <div class="items" *ngFor="let pessoa of pessoasSelecionadas">
        <span>{{ pessoa.nome }}</span>
      </div>
    </div>
  </div>
  <div class="buttons">
    <button
      matButton="outlined"
      (click)="removerAviso()"
      *ngIf="canRemoveAviso()"
    >
      Remover aviso
    </button>
    <button
      matButton="filled"
      (click)="editarAviso(aviso.id)"
      *ngIf="isNosStatusRascunho()"
    >
      Editar aviso
    </button>
  </div>
</div>
